import React from "react"
import { ReportAPI } from "../../lib/utils"
import ReportForm from "./ReportForm"

export default function LoanDisbursedReport() {
  return <ReportForm reportAPI={ ReportAPI.LOAN_DISBURSED } />
}



// WEBPACK FOOTER //
// ./src/components/Reports/LoanDisbursedReport.js